<template>
    <el-dialog
        title="完善个人信息"
        :visible="visible"
        width="500px"
        :before-close="handleClose"
        :close-on-click-modal="false">
        <el-form :inline="true" ref="ruleForm" :model="formData" :rules="rules" label-width="100px" label-position="left">
            <p class="color_primary mb20">请至少填写以下任意一项信息，即可获得 <span class="em">{{rewardType}} {{info.rewardCnt}}</span>个</p>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="formData.phone" maxlength="100" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
            <el-form-item label="微信号" prop="wechat">
                <el-input v-model="formData.wechat" maxlength="100" placeholder="请输入微信号" clearable></el-input>
            </el-form-item>
            <el-form-item label="QQ" prop="qq">
                <el-input v-model="formData.qq" maxlength="100" placeholder="请输入QQ" clearable></el-input>
            </el-form-item>
            <el-form-item label="WhatsApp" prop="whatsapp">
                <el-input v-model="formData.whatsapp" maxlength="100" placeholder="请输入WhatsApp号" clearable></el-input>
            </el-form-item>
            <el-form-item label="Telegram" prop="telegram">
                <el-input v-model="formData.telegram" maxlength="100" placeholder="请输入Telegram用户名" clearable></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleCancel" size="small">取 消</el-button>
            <el-button type="primary" @click="handleConfirm" size="small">确 定</el-button>
        </span>
    </el-dialog>
  </template>
  
  <script>
  import { improveEdit, dictList } from '@/api/auth';
  export default {
    name: 'ComplateInfoComponents',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        info: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            formData: {
                phone: '',
                wechat: '',
                qq: '',
                whatsapp: '',
                telegram: ''
            },
            rules: {
                // phone: [{ validator: this.validateAtLeastOne, trigger: 'change' }],
                // wechat: [{ validator: this.validateAtLeastOne, trigger: 'change' }],
                // qq: [{ validator: this.validateAtLeastOne, trigger: 'change' }],
                // whatsapp: [{ validator: this.validateAtLeastOne, trigger: 'change' }],
                // telegram: [{ validator: this.validateAtLeastOne, trigger: 'change' }]
            },
            types: [],
            rewardCnt: ''
        }
    },
    computed: {
        rewardType() {
            let item = this.types.find((op) => op.dictValue === this.info.rewardType);
            return item?.dictLabel || ''
        }
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            dictList('sys_user_improve_type').then((res) => {
                this.types = res.data;
            }).catch((err) => {})
        },
        validateAtLeastOne() {
            const { phone, wechat, qq, whatsapp, telegram } = this.formData;
            if (phone || wechat || qq || whatsapp || telegram) {
                return true 
            } else {
                this.$message.error('请至少填写一个联系方式');
                return false 
            }
        },
        handleClose(done) {
            this.formData = {
                phone: '',
                wechat: '',
                qq: '',
                whatsapp: '',
                telegram: ''
            }
            this.$refs['ruleForm'].resetFields();
            this.$emit('update:visible', false);
            done && done()
        },
        handleCancel() {
            this.handleClose(); 
        },
        handleConfirm() {
            if(!this.validateAtLeastOne()) {
                return
            }
            improveEdit(this.formData).then((res) => {
                this.$message.success('信息完善成功！')
                this.$emit('confirm');
                this.handleClose();
            }).catch(() => {

            })
            // this.$refs['ruleForm'].validate((valid) => {
            //     if (valid) {
                    
            //     }
            // });
        },
    },
    filters: {
        formatType(val) {
            if(val === 1) {
                return ''
            }
        }
    }
  };
  </script>

<style lang="scss" scoped>
::v-deep(.el-form--inline .el-form-item){
    width: 100%;
}
::v-deep(.el-form-item--medium .el-form-item__content){
    width: calc(100% - 100px)
}
.em{
    font-weight: bold
}
</style>
